import React, { useRef, useState } from "react";

import { Chip } from "@mui/material";

import DocumentsViewModal from "components/Screens/Timeoff/ManageTimeoff/PendingLeaves/PendingLeavesCard/DocumentsList/DocumentsViewModal";

import { downloadLeaveDocument } from "services/useTimeoffService";

import {
  PictureAsPdfOutlined as PictureAsPdfOutlinedIcon,
  InsertPhotoOutlined as InsertPhotoOutlinedIcon,
} from "@mui/icons-material";

import "./DocumentList.scss";

function DocumentsList({
  documents,
  maxChipsPerRow = 3,
  source = "",
  pending = false,
  employeeId = "",
  collapsed = true,
}) {
  const [showDocumentsViewModal, setShowDocumentsViewModal] = useState(false);
  const downloadTimeoutRef = useRef(false);

  if (!documents?.length) return null;

  const containerClass =
    source === "customer-timeoff" && !pending ? "time-off-details-customer" : " pending-timeoff-details";

  const titleClass =
    source === "customer-timeoff"
      ? `pending-timeoff-text-customer${pending ? " pending" : ""}${collapsed === false ? " collapsed" : ""}`
      : "pending-timeoff-text-emp";

  return (
    <div className={containerClass}>
      <div className={titleClass}>Documents</div>
      {documents?.slice(0, maxChipsPerRow)?.map(({ extension, name, documentId }) => (
        <Chip
          icon={
            extension === ".pdf" ? (
              <PictureAsPdfOutlinedIcon className="document-list-chip-icon" />
            ) : (
              <InsertPhotoOutlinedIcon className="document-list-chip-icon" />
            )
          }
          className="custom-chip document-list-chip"
          variant="outlined"
          title={name}
          label={
            <p className={`para-body-s-regular file-name-container ${documents?.length > 1 ? "multi-doc-label" : ""}`}>
              {name}
            </p>
          }
          onClick={() => {
            if (!downloadTimeoutRef.current) {
              downloadTimeoutRef.current = true;
              downloadLeaveDocument(documentId, name, employeeId);
              setTimeout(() => {
                downloadTimeoutRef.current = false;
              }, 1000);
            }
          }}
        />
      ))}
      {documents?.length > maxChipsPerRow ? (
        <Chip
          className="custom-chip document-list-chip"
          variant="outlined"
          label={<p className="para-body-s-regular">+{documents?.length - maxChipsPerRow} more</p>}
          onClick={() => setShowDocumentsViewModal(true)}
        />
      ) : null}

      <DocumentsViewModal
        documents={documents}
        showDocumentsViewModal={showDocumentsViewModal}
        setShowDocumentsViewModal={setShowDocumentsViewModal}
        employeeId={employeeId}
      />
    </div>
  );
}

export default DocumentsList;
